export default __webpack_public_path__ + "static/media/a018-2.3ef9ddfe.svg";